/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2020, 2024. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */

// Code adapted from pipeline-ui/tekton/lib/components/Config/Tabs/InputBoxIcon.jsx

import React from "react";
import { Close, Password, SubtractAlt, View, ViewOff } from "@carbon/react/icons";
export default function InputBoxIcon(props) {
  var analyticsLabel = props.analyticsLabel,
    className = props.className,
    disabled = props.disabled,
    iconName = props.iconName,
    id = props.id,
    onClick = props.onClick,
    title = props.title;
  return /*#__PURE__*/React.createElement("button", {
    "aria-label": title,
    className: "".concat(className || "", " ocr--icon-button cds--copy-btn"),
    "data-analytics-label": analyticsLabel,
    disabled: disabled,
    id: id,
    onClick: onClick,
    title: title,
    type: "button"
  }, iconName === "view" && /*#__PURE__*/React.createElement(View, {
    size: "20"
  }), iconName === "viewoff" && /*#__PURE__*/React.createElement(ViewOff, {
    size: "20"
  }), iconName === "key" && /*#__PURE__*/React.createElement(Password, {
    size: "20"
  }), iconName === "close" && /*#__PURE__*/React.createElement(Close, {
    size: "20"
  }), iconName === "subtractalt" && /*#__PURE__*/React.createElement(SubtractAlt, {
    size: "20"
  }));
}